import {
  IItem,
  INameGroupEmptyValidatable,
  instanceOfIHisInformationApplicable,
} from "../items";
import { AbstractEmptyAlert } from "./AbstractEmptyAlert";

export class NameGroupEmptyAlert extends AbstractEmptyAlert<IItem & INameGroupEmptyValidatable> {
  constructor(itemSetId: number, item: IItem & INameGroupEmptyValidatable) {
    super(itemSetId, item, !item.enableEmptyCheckConfirmation);
  }

  get kind(): string {
    return "名称警告";
  }

  protected get itemName(): string {
    return (instanceOfIHisInformationApplicable(this._detectedItem) && this._detectedItem.isHisInfo && !!this._detectedItem.hisItemParameter)
      ? this._detectedItem.hisItemParameter.displayName
      : this._detectedItem.name;
  }
}
